module.exports = __webpack_public_path__ + "img/car-gray.95cf4818.svg";